import { EMenuProfile } from './enums'
import {
  AvatarWrapperStyled,
  HeadContainer,
  HeadTitle,
  HeadWrapper,
  Notification,
  StyleMenuItem,
  StyleWrapperIconArrow,
  StyledStrong,
  StyledUserName,
  Title
} from './index.styled'
import { KeyOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Col, Dropdown, Menu, Row, notification } from 'antd'
import { useAuth } from 'auth'
import classNames from 'classnames'
import { Switch } from 'components/atoms'
import { NO_DATA } from 'constants/common'
import { ERegistrationStatus } from 'enums/ERegistrationStatus'
import { useModal, useProfile } from 'hooks'
import ChangePassword from 'pages/login/changePassword'
import BookingNotification from 'pages/notifications/components/BookingNotification'
import { FC, ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { useClinicServices } from 'services'
import styled from 'styled-components'

export type HeadProps = {
  title?: string | ReactNode
  description?: string
  className?: string
}
const StyledCenteredNotification = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ff0042;
  color: #ffffff;
  text-align: center;
  padding: 10px 0;
`

const HeaderNotification: FC<HeadProps> = ({
  title,
  description,
  children,
  ...props
}) => {
  const [loading, setLoading] = useState(false)
  const { userProfile, onLogout, activeUser, isAuth, activeRole } = useAuth()
  const { t } = useTranslation()
  const { updateClinic } = useClinicServices()
  const { profile, userId, reloadUserProfile } = useProfile()
  const location = useLocation()
  const [activeClinic, setActiveClinic] = useState(false)
  const modal = useModal()

  useEffect(() => {
    setActiveClinic(!!profile?.is_active)
  }, [profile?.is_active])

  const handleLogOut = () => {
    onLogout()
  }

  const handleChangePassword = () => {
    modal.open(
      <ChangePassword />,
      { footer: null, title: t('change-password') },
      () => {}
    )
  }

  const handleActiveClinic = async (checked: boolean) => {
    setLoading(true)
    const profile = await reloadUserProfile()
    if (
      profile?.registration_status !== ERegistrationStatus.Approve ||
      profile?.my_clinic_user?.clinic_role.role.toLowerCase().trim() !==
        'sysadmin'
    ) {
      notification.warning({ message: t('do-not-have-permission') })
      // setActiveClinic(false)
      setLoading(false)
      return
    }
    const res = await updateClinic({
      user_id: userId,
      is_active: checked
    })
    if (res._successfully) {
      notification.success({ message: t('update-success') })
      setActiveClinic(checked)
    }
    setLoading(false)
  }

  const handleOnClick = (e: any) => {
    switch (Number(e?.key)) {
      case EMenuProfile.Logout:
        handleLogOut()
        break
      case EMenuProfile.ChangePassword:
        handleChangePassword()
        break
    }
  }

  const menu = (
    <Menu
      onClick={handleOnClick}
      items={[
        {
          label: (
            <StyleMenuItem>
              <Row align="middle">
                <Col>
                  <UserOutlined />
                </Col>
                <Col>
                  <Row>
                    <StyledStrong>
                      {profile?.my_clinic_user?.full_name}
                    </StyledStrong>
                  </Row>
                  <Row>{profile?.my_clinic_user?.email}</Row>
                </Col>
              </Row>
            </StyleMenuItem>
          ),
          key: EMenuProfile.Email
        },
        {
          label: (
            <StyleMenuItem>
              <img src="./images/ic-phone.svg"></img>
              {profile?.my_clinic_user?.phone_number || NO_DATA}
            </StyleMenuItem>
          ),
          key: EMenuProfile.PhoneNumber
        },
        {
          label: (
            <StyleMenuItem>
              <img src="./images/ic-multigender.svg"></img>
              {profile?.my_clinic_user?.gender
                ? t(`gender-${profile?.my_clinic_user?.gender}`)
                : NO_DATA}
            </StyleMenuItem>
          ),
          key: EMenuProfile.Gender
        },
        {
          label: (
            <StyleMenuItem>
              <KeyOutlined />
              {t('change-password')}
            </StyleMenuItem>
          ),
          key: EMenuProfile.ChangePassword
        },
        {
          label: (
            <StyleMenuItem>
              <LogoutOutlined />
              {t('log-out')}
            </StyleMenuItem>
          ),
          key: EMenuProfile.Logout
        }
      ]}
    />
  )

  return (
    <>
      {(!activeUser && isAuth) || !activeRole ? (
        <StyledCenteredNotification>
          <p>
            Tài khoản của bạn đã bị tạm ngưng hoạt động. Xin vui lòng liên hệ
            admin {`${userProfile?.clinic_name}`} để được hỗ trợ
          </p>
        </StyledCenteredNotification>
      ) : null}
      <HeadContainer
        {...props}
        className={classNames('header-notification', props?.className)}>
        <HeadWrapper>
          {!children && (
            <HeadTitle>
              <Title>{title}</Title>
              {!!description && (
                <div className="description">{description}</div>
              )}
              {location.pathname === '/' && (
                <Switch
                  loading={loading}
                  onChange={handleActiveClinic}
                  value={activeClinic}
                  description={['pause', 'active']}
                />
              )}
            </HeadTitle>
          )}
          {!!children && children}
        </HeadWrapper>
        <Notification>
          <BookingNotification />
          <Dropdown overlay={menu} trigger={['click']}>
            <AvatarWrapperStyled>
              <Row>
                <Avatar
                  size={26}
                  src={userProfile?.cover_image_url}
                  icon={
                    profile?.cover_image_url ? (
                      <img src={profile.cover_image_url} alt="" />
                    ) : (
                      profile?.clinic_name?.[0]
                    )
                  }
                />
                <Col>
                  <StyledUserName>{profile?.clinic_name}</StyledUserName>
                </Col>
              </Row>

              <StyleWrapperIconArrow className="btn-arrow">
                <img src="./images/ic-arrow-bottom.svg" alt="" />
              </StyleWrapperIconArrow>
            </AvatarWrapperStyled>
          </Dropdown>
        </Notification>
      </HeadContainer>
    </>
  )
}

export default HeaderNotification
